/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard Service
 * This is the API documentation of the Dashboard service
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LossOfProductionMetricUpdateRequest
 */
export interface LossOfProductionMetricUpdateRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof LossOfProductionMetricUpdateRequest
     */
    name?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof LossOfProductionMetricUpdateRequest
     */
    lc?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof LossOfProductionMetricUpdateRequest
     */
    licenseFeatures?: Array<string>;
}

/**
 * Check if a given object implements the LossOfProductionMetricUpdateRequest interface.
 */
export function instanceOfLossOfProductionMetricUpdateRequest(value: object): value is LossOfProductionMetricUpdateRequest {
    return true;
}

export function LossOfProductionMetricUpdateRequestFromJSON(json: any): LossOfProductionMetricUpdateRequest {
    return LossOfProductionMetricUpdateRequestFromJSONTyped(json, false);
}

export function LossOfProductionMetricUpdateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): LossOfProductionMetricUpdateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'lc': json['lc'] == null ? undefined : json['lc'],
        'licenseFeatures': json['licenseFeatures'] == null ? undefined : json['licenseFeatures'],
    };
}

export function LossOfProductionMetricUpdateRequestToJSON(json: any): LossOfProductionMetricUpdateRequest {
    return LossOfProductionMetricUpdateRequestToJSONTyped(json, false);
}

export function LossOfProductionMetricUpdateRequestToJSONTyped(value?: LossOfProductionMetricUpdateRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'lc': value['lc'],
        'licenseFeatures': value['licenseFeatures'],
    };
}

